import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Route, Switch } from 'react-router';
import { FormattedMessage } from 'react-intl';

import ModalStore from 'stores/ModalStore';
import { ROUTES } from 'routes/routes';

import NavigationTabs from 'components/NavigationTabs/NavigationTabs';
import MenuDesignModal from 'components/Modals/MenuDesign/MenuDesignModal';
import Button from 'components/Button/Button';
import MenuLines from './MenuLines/MenuLines';
import Planner from './Planner/Planner';
import style from './MenuPage.module.scss';
import RootStore from 'stores/RootStore';

@observer
class MenuPage extends Component {
  private _handleMenuDesignClick = () => {
    ModalStore.showModal(MenuDesignModal);
  };

  render() {
    return (
      <div className={style.content__tabs}>
        <div className={style.header}>
          <NavigationTabs
            tabs={[
              { to: ROUTES.admin.menu, title: 'title.menu' },
              { to: ROUTES.admin.menuLines, title: 'title.menuLines' },
            ]}
          />
          <div className={style.actions}>
            {RootStore.config.feature.weekMenu?.enabled && (
              <Button
                className={style.btn}
                styleType="text"
                onClick={this._handleMenuDesignClick}
              >
                <FormattedMessage id="title.menuDesign" />
              </Button>
            )}
          </div>
        </div>

        <Switch>
          <Route path={ROUTES.admin.menu} component={Planner} exact />
          <Route path={ROUTES.admin.menuLines} component={MenuLines} exact />
        </Switch>
      </div>
    );
  }
}

export default MenuPage;
